import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const Container = styled.button`
  display: block;
  color: #000;
  font-size: 15px;
  font-weight: 600;
  font-family: Basier Circle;
  letter-spacing: -0.2px;
  line-height: 1.3;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #ddd;
  border-radius: 75px;
  padding: 12px 25px !important;
  cursor: pointer;

  > a {
    text-decoration: none !important;
    color: #111;
  }

  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${props =>
    props.light &&
    css`
      color: #000;
      background-color: white;

      :hover {
        border-color: #000;
      }
    `}

  ${props =>
    props.dark &&
    css`
      background-color: #111;
      color: #fff;
      border: 1px solid #fff;
    `}
`;

function Button(props) {
  return (
    <Container {...props} onClick={() => props.onClick()}>
      {props.children}
    </Container>
  );
}

Button.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Button/index.jsx